module.exports = __webpack_public_path__ + "img/PL00189.fa9005af.png";